// NOTE: NSAI-1606 — the obfuscation map for the public GET /app-config
// response. Every group name and every field name inside a group travels as a
// random 6-char hex key, so an unauthenticated viewer reading DevTools does not
// learn which integrations (Telegram, Kontur, Jitsi, ...) a deployment runs.
// Values that are themselves objects (flavor, links, AI providers) keep their
// own field names: a client validates those, it does not just test presence.
//
// IMPORTANT: this map is duplicated in
// apps/nsai/server/src/app-config/app-config-wire-keys.ts and the two must stay
// identical. A key that drifts decodes to its safe default — the feature simply
// reads as off — so the server's spec diffs the two files to catch it.
export const APP_CONFIG_WIRE_KEYS = {
  deployment: {
    key: "dd96e4",
    fields: {
      isOnPremise: "d74626",
      isClosedNetwork: "619a74",
      isBillingDisabled: "a3f72b",
      isDomainVerificationUnavailable: "3a6f82",
      flavor: "7ee604",
      apiCapabilities: "a4857d",
      pushPlatforms: "754240",
      minMobileAppVersion: "05c835",
      links: "44b697",
    },
  },
  auth: {
    key: "bb7ae6",
    fields: {
      isSsoVisible: "1a4b6c",
      isPasswordAuthDisabled: "0d63ae",
      isSignUpEnabled: "fc0c7c",
      socialProviders: "1c9729",
      isPasswordResetSelfService: "423ece",
      isSamlSeatTiersEnabled: "5c9d13",
    },
  },
  features: {
    key: "c3d064",
    fields: {
      isAgentsEnabled: "e07b2f",
      isSkillsEnabled: "7c3e58",
      isSkillScriptExecutionAvailable: "b2f47a",
      isCustomIntegrationEnabled: "3c8f1a",
      isCodeSessionsEnabled: "b443b2",
      isExternalIntegrationsProviderEnabled: "2f9b67",
      isDocRecognitionEnabled: "b1e64d",
      isBrandedPresentationsEnabled: "5f1c93",
      isUserMemoryEnabled: "d2b7a4",
      isZipArchiveUploadEnabled: "f4b90c",
      isAdminPanelEnabled: "d59a31",
      isModelApprovalEnabled: "c6a80b",
      isSyncatorApiEnabled: "9b4e2c",
      isMobileChatSearchEnabled: "8f24b1",
      isTokenUsageEnabled: "4a8b91",
      isTokenCostUsageEnabled: "7b3e6f",
      isUserAnalyticsEnabled: "a6d3f9",
      isTokenLimitsEnabled: "3e7d52",
      isCallAssistantFeaturesEnabled: "4a1e8d",
      isCallAssistantFeaturesEnabledFF: "8e3d52",
      isAnonymizationLabEnabled: "d81f3a",
      isAnonymizationLabEnabledFF: "e5c204",
      isModelSubscriptionConnectionsEnabled: "e8e46f",
      isModelSubscriptionConnectionsEnabledFF: "4188a7",
      isFinancialMaskingFeatureEnabled: "9a31c7",
      isPiiCustomEntitiesFeatureEnabled: "b7e29d",
      isPiiAdvancedRulesFeatureEnabled: "cc845f",
      isPiiIntentRoutingFeatureEnabled: "3c7f5e",
      isSiemExportEnabled: "7c3ea5",
      isSiemGlobalCollectorActive: "6ba413",
    },
  },
  bots: {
    key: "cb337f",
    fields: {
      isTelegramBotEnabled: "c4d77e",
      isWhatsappBotEnabled: "a7d3f1",
      isWhatsappBotEnabledFF: "e4b19c",
      isMatrixBotEnabled: "6e2b90",
      slackBotUri: "7e2a91",
      teamsBotUri: "bc5f08",
    },
  },
  meetings: {
    key: "dcca44",
    fields: {
      isKonturTalkEnabled: "813dc5",
      isYandexTelemostEnabled: "27c9f4",
      isSaluteJazzEnabled: "6d05b8",
      jitsiCustomDomains: "62fe48",
      enabledCalendars: "70b3a9",
      meetingBotEmail: "e81c4d",
    },
  },
  audio: {
    key: "7bf6bc",
    fields: {
      isAudioTranscriptionEnabled: "5b8e10",
      isExternalServiceForAudioTranscription: "f2a649",
      isTtsEnabled: "1a8c93",
      isExternalServiceForTts: "4e5fbd",
      ttsVoices: "9c47e1",
    },
  },
  map: {
    key: "62ac13",
    fields: {
      tileUrl: "4cea9e",
      tileAttribution: "755e48",
      maxZoom: "c62a8c",
    },
  },
  limits: {
    key: "669093",
    fields: {
      maxFileUploadCount: "9c1e44",
      knowledgeMaxFileSizeMb: "eb11b3",
    },
  },
  analytics: {
    key: "92ea5a",
    fields: {
      isEnabled: "620995",
      posthogKey: "c08bfe",
      posthogHost: "a5719c",
    },
  },
  legal: {
    key: "7a790e",
    fields: {
      supportEmail: "4d8e07",
      privacyPolicyUrl: "dbc16b",
      termsUrl: "67a2c5",
    },
  },
  policies: {
    key: "035eb1",
    fields: {
      isAccountDeletionEnabled: "6b53cc",
    },
  },
  ai: {
    key: "872900",
    fields: {
      providers: "39ecfc",
    },
  },
} as const;
